import Model from '../../ModelBinding/Model';
import LanguageTranslationCollection from './LanguageTranslationCollection';
import dayjs from 'dayjs';

export default class LanguageTranslation extends Model {
  public locale?: string;
  public name?: string;
  public created_at?: dayjs.Dayjs;
  public updated_at?: dayjs.Dayjs;

  bind() {
    this.locale = this.getStringAttribute('locale');
    this.name = this.getStringAttribute('name');
    this.created_at = this.getDateAttribute('created_at');
    this.updated_at = this.getDateAttribute('updated_at');
  }

  static getCollection() {
    return LanguageTranslationCollection;
  }
}
